import React, { useContext, useRef, useState } from 'react';
import { Box, Button, Grid, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { EmailContext } from '../Context/EmailContext';
import CustomToast from './CustomToast/CustomToast';
import FormSettingSelect from './FormSettingSelect';

import { emailTypeModal, initialFormState, modalOption, securityProtocolData } from '../Constant/AdvanceTab';
import { toast } from 'react-toastify';
import { hasInputErrors, isFormDataValid, validateInputChange } from './AdvanceTab/validation';
import { filterEmailData } from './AdvanceTab/dataUtils';
import { postEmailData } from './AdvanceTab/api';
import EmailFormFields from './AdvanceTab/EmailFormFields';

const AdvanceTab = () => {

  const { emails, addEmails } = useContext(EmailContext);
  const location = useLocation();
  const currentPage = location.pathname;

  const sliceIndex = currentPage.startsWith('/setting/email-setting/notification-email/advance') ? -9 : -10;
  const updateEmails = emails.slice(sliceIndex);

  const [selectValues, setSelectValues] = useState(initialFormState);
  const [showPassword, setShowPassword] = useState(false);

  const optionRef = useRef();
  const emailTypeSelectRef = useRef();

  const handleSelectChange = (name, value) => {
    const updated = [...selectValues];
    const index = updated.findIndex((s) => s.name === name);
    if (index !== -1) {
      updated[index].value = value;
    } else {
      updated.push({ name, value });
    }
    setSelectValues(updated);
  };

  const handleInputChange = (e, id) => {
    const { value, type } = e.target;
    const error = validateInputChange(type, value);

    setSelectValues(prev =>
      prev.map(item =>
        item.id === id ? { ...item, value, typeError: error } : item
      )
    );
  };

  const handlePasswordToggle = () => {
    setShowPassword(!showPassword);
    setSelectValues(prev =>
      prev.map(item =>
        item.name === 'Password' ? { ...item, type: !showPassword ? 'text' : 'password' } : item
      )
    );
  };

  const handleValidate = () => {
    if (selectValues[0].value === 'noreply@jotform.com') return true;
    if (selectValues[1]?.value === 'Please Select' || isFormDataValid(selectValues) || hasInputErrors(selectValues)) {
      toast(<CustomToast message={'لطفا تمام فرم ها را با دقت پر کنید'} state={'error'} />);
      return false;
    }
    return true;
  };

  const handleAddEmail = async () => {
    if (!handleValidate()) return;

    const payload = filterEmailData(selectValues, updateEmails);
    addEmails(payload);

    const response = await postEmailData(payload);
    if (response.success) {
      toast(<CustomToast message={'ایمیل با موفقیت افزوده شد'} state={'success'} />);
      setSelectValues(initialFormState);
    } else {
      toast(<CustomToast message={'خطا در ارسال ایمیل'} state={'error'} />);
    }
  };

  return (
    <>
      <Box bgcolor="white" p={{ xs: '21px', sm: '21px 42px' }} mb="24px">
        <Typography variant="h6" color="#23283a" fontWeight={600}>ایمیل فرستنده</Typography>
        <Typography variant="h6" color="#23283a" fontWeight={500}>یک آدرس ایمیل را برای نشان دادن به عنوان فرستنده انتخاب کنید</Typography>

        <FormSettingSelect
          options={modalOption}
          id={0}
          name="advanceCustomizeSaveEmail"
          onSelectChange={handleSelectChange}
          ref={optionRef}
        />

        {selectValues[0].value !== "noreply@jotform.com" && (
          <Grid className="moreOption" mt="55px">
            <Typography variant="h6" color="#23283a" fontWeight={600}>نوع ایمیل</Typography>
            <FormSettingSelect
              ref={emailTypeSelectRef}
              options={emailTypeModal}
              name="EmailType"
              id={0}
              onSelectChange={handleSelectChange}
              border={selectValues[1]?.value === "Please Select"}
            />
            {selectValues[1]?.value === "Please Select" && (
              <Typography variant="body1" color="#d53049" p="8px 0">نوع ایمیل مورد نیاز است.</Typography>
            )}

            <EmailFormFields
              values={selectValues}
              onChange={handleInputChange}
              onTogglePassword={handlePasswordToggle}
              showPassword={showPassword}
              setTouched={setSelectValues}
            />

            <Typography variant="h6" color="#23283a" fontWeight={600} mb={1}>پروتکل امنیتی</Typography>
            <FormSettingSelect
              options={securityProtocolData}
              name="Security Protocol"
              id={0}
              onSelectChange={handleSelectChange}
            />

            <Button
              fullWidth
              onClick={handleAddEmail}
              sx={{
                mt: 2,
                padding: '11px',
                backgroundColor: 'rgba(0,117,227,1)',
                borderRadius: '4px',
                color: 'white',
                '&:hover': { backgroundColor: 'rgba(0,117,227,1)' },
              }}
            >
              افزودن ایمیل
            </Button>
          </Grid>
        )}
      </Box>

      <Grid display="flex" justifyContent="space-between" mb="48px">
        <Grid onClick={handleAddEmail} className="save" p="12px 16px" bgcolor="rgba(100,178,0,1)" color="white" borderRadius="4px" style={{ cursor: 'pointer' }}>ذخیره</Grid>
        <Grid className="text" p="12px 16px" bgcolor="rgba(218,222,243,1)" color="rgba(52,60,106,1)" borderRadius="4px" style={{ cursor: 'pointer' }}>تست ایمیل</Grid>
      </Grid>
    </>
  );
};

export default AdvanceTab;